import { checkRootDataAreFetched } from '@client/composition/router/application/routes/check-root-data-are-fetched.route-guard';
import { ensureSelectedClientIsInitializedGuard } from '@client/common/router/application/routes/ensure-selected-client-is-initialized.route-guard';
import { isPublicRoute } from '@shared/feature/landing/application/helper/is-public-route.helper';
import { checkCustomerChatbotInitialized } from '@client/feature/customer-chatbots/application/routes/check-customer-chatbot-initialized.route-guard';
import { LoginRouteName } from '@shared/feature/login/application/routes/login.route-name';
import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';

export async function globalGuard(to: RouteLocationNormalized): Promise<boolean | RouteLocationRaw> {
  if (isPublicRoute(to.name)) {
    return checkCustomerChatbotInitialized({
      identifyChatbotVisitorWithAuthenticatedUser: to.name !== LoginRouteName.Login,
    });
  }

  const rootDataResult = await checkRootDataAreFetched();

  if (rootDataResult !== true) {
    return rootDataResult;
  }

  const selectedClientResult = await ensureSelectedClientIsInitializedGuard();

  if (selectedClientResult !== true) {
    return selectedClientResult;
  }

  return checkCustomerChatbotInitialized({
    identifyChatbotVisitorWithAuthenticatedUser: true,
  });
}
